import {
    collection,
    doc,
    updateDoc,
    where,
    getDocs,
    Timestamp,
    addDoc,
    deleteDoc,
    getFirestore,
    query,
} from 'firebase/firestore';
import { db } from '../../../config/firebase';
import DbCollections from '../../../resources/enums/DbCollections';
import { ChatSchedule, DateRange } from '../types';

export const getScheduleListFirebase = async (range: DateRange) => {
    const start = Timestamp.fromDate(range.startTime);
    const end = Timestamp.fromDate(range.endTime);
    const snapshot = await getDocs(
        query(
            collection(getFirestore(), DbCollections.ChatSchedule),
            where('startTime', '>=', start),
            where('startTime', '<', end),
        ),
    );
    const ret = snapshot.docs.map((doc) => {
        const data = doc.data();
        return {
            id: doc.id,
            startTime: data.startTime,
            endTime: data.endTime,
        } as ChatSchedule;
    });
    return ret;
};

export const deleteScheduleFirebase = async (id: string) => {
    await deleteDoc(doc(db, DbCollections.ChatSchedule, id));
};

export const updateScheduleFirebase = async (schedule: ChatSchedule) => {
    await updateDoc(doc(db, DbCollections.ChatSchedule, schedule.id), {
        startTime: schedule.startTime,
        endTime: schedule.endTime,
    });
};
export const addScheduleFirebase = async (schedule: ChatSchedule) => {
    const doc = await addDoc(collection(db, DbCollections.ChatSchedule), {
        startTime: schedule.startTime,
        endTime: schedule.endTime,
    });
    return {
        ...schedule,
        id: doc.id,
    };
};
